import { Delivery } from "../../components";
import "./stylesCategoriaDelivery.scss";

export const CategoriaDelivery = () => (
  <div>
    <Delivery />
  </div>
);
